import { Button, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import OrderListTable from './OrderListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { User } from '../../Models/User';
import { useAppSelector } from '../../Reducers/store';
import { UserLevelNames } from '../../Models/UserLevel';
import { useParams } from 'react-router-dom';
import UserApi from '../../Api/UserApi';
import { HiPlus } from 'react-icons/hi';
import { Order } from '../../Models/Order';
import OrderApi from '../../Api/OrderApi';
import OrderView from './OrderView';

export default function OrderList() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [orderListData, setorderListData] = useState<Order[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showOrder, setshowOrder] = useState<boolean>(false);
  const [selectedOrder, setselectedOrder] = useState<Order | null>(null);

  useEffect(() => {
    getOrders();
  }, [userModel]);

  const getOrders = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return OrderApi.getOrderList()
          .then((res) => {
            console.log(res.data);
            setorderListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  const showOrderForm = (order: Order) => {
    setselectedOrder(order);
    setshowOrder(true);
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Order List</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          <div className='relative'>
            {isLoading && <Loader />}
            <OrderListTable
              data={orderListData}
              showOrderForm={showOrderForm}
            />
          </div>
        </div>
      </div>
      <OrderView
        show={showOrder}
        setShow={setshowOrder}
        selectedOrder={selectedOrder}
        setSelectedOrder={setselectedOrder}
      />
    </>
  );
}
